import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FaPencilAlt, FaPlus, FaSave } from 'react-icons/fa';
import { FcDeleteRow } from 'react-icons/fc';
import { Loader } from '../../components/Loader/Loader';
import {
  CourierObj,
  InboundInfoFormatted,
  ShopArray,
} from '../../fetch/fetchInbound';
import {
  fetchCreateInbound,
  fetchUpdateInbound,
} from '../../fetch/fetchUpdateInbound';
import { useGetInboundInfo } from '../../hooks/useGetInboundInfo';
import { ButtonComponent } from '../../ReusableComponents/Button/ButtonComponent';
import { InputComponent } from '../../ReusableComponents/Input/InputComponent';
import analyticsWrapper from '../../utils/analyticsWrapper';
import { courierName } from '../courierArea/ShowCourierAreaData';
import { EditCourierBox } from './EditCourierBox';
import { EditShops } from './EditShops';
import './ShowInboundData.scss';
import { ShowShops } from './ShowShops';
import { fetchRemoveInbound } from '../../fetch/fetchRemoveInbound';

export function ShowInboundData(): JSX.Element {
  return (
    <div className={'posistionDataTable'}>
      <ShowInboundDataTable />
    </div>
  );
}

const useStyles = makeStyles({
  table: {
    minWidth: 300,
  },

  tableRow: {
    backgroundColor: '#4d4d4d',
    color: 'white',
  },

  cellTop: {
    color: 'white',
    fontSize: '16px',
    fontWeight: 500,
  },
});

export function ShowInboundDataTable(): JSX.Element {
  const [addRow, setAddRow] = useState<boolean>(false);

  const { inboundInfoList, isLoading } = useGetInboundInfo();

  const [activeInboundList, setActiveInboundList] =
    useState<InboundInfoFormatted[]>(inboundInfoList);
  useEffect(() => {
    setActiveInboundList(inboundInfoList);
  }, [inboundInfoList]);

  const tableStyle = useStyles();

  function updateActiveInboundList(
    newInboundItem: InboundInfoFormatted,
    indexOfNewInboundItem,
    type: string
  ): void {
    if (type === 'REPLACE') {
      const NewList: InboundInfoFormatted[] = activeInboundList.map(
        (row, i) => {
          if (i === indexOfNewInboundItem) {
            return newInboundItem;
          } else {
            return row;
          }
        }
      );
      setActiveInboundList(NewList);
    } else if (type === 'DELETE') {
      const NewList: InboundInfoFormatted[] = activeInboundList.filter(
        (row, i) => {
          if (i === indexOfNewInboundItem) {
            return false;
          } else {
            return true;
          }
        }
      );
      setActiveInboundList(NewList);
    } else if (type === 'ADD') {
      const NewList: InboundInfoFormatted[] = [
        ...activeInboundList,
        newInboundItem,
      ];
      setActiveInboundList(NewList);
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      {!isLoading && (
        <>
          <TableContainer component="div">
            <Table className={tableStyle.table} size={'medium'} component="div">
              <TableHead component="div">
                <TableRow className={tableStyle.tableRow} component="div">
                  <TableCell className={tableStyle.cellTop} component="div">
                    Action
                  </TableCell>
                  <TableCell className={tableStyle.cellTop} component="div">
                    Line haul Name
                  </TableCell>
                  <TableCell className={tableStyle.cellTop} component="div">
                    Courier name
                  </TableCell>
                  <TableCell className={tableStyle.cellTop} component="div">
                    Shop List
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody component="div">
                {activeInboundList &&
                  activeInboundList.map(
                    (inboundInfoRow: InboundInfoFormatted, i: number) => (
                      <InboundRow
                        key={i}
                        inboundInfoRow={inboundInfoRow}
                        i={i}
                        updateActiveInboundList={updateActiveInboundList}
                      />
                    )
                  )}
                {addRow && (
                  <CreateInboundData
                    inboundInfoRow={null}
                    mode={'ADD'}
                    i={0}
                    updateActiveInboundList={updateActiveInboundList}
                    closeEditMode={() => setAddRow(false)}
                  />
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {!addRow && (
            <ButtonComponent
              variant="outlined"
              onClick={() => {
                analyticsWrapper.event({
                  category: 'inBound-config',
                  action: `add-inbound-row`,
                  label: 'click',
                });
                setAddRow(true);
              }}
              startIcon={<FaPlus />}
            >
              {'Add lineHaul'}
            </ButtonComponent>
          )}
        </>
      )}
    </>
  );
}

function InboundRow({
  inboundInfoRow,
  i,
  updateActiveInboundList,
}: {
  inboundInfoRow: InboundInfoFormatted;
  i: number;
  updateActiveInboundList: (
    newInboundItem: InboundInfoFormatted,
    indexOfNewInboundItem: number,
    type: string
  ) => void;
}): JSX.Element {
  const [showEditConfigModal, setShowEditConfigModal] =
    useState<boolean>(false);
  if (showEditConfigModal) {
    return (
      <CreateInboundData
        inboundInfoRow={inboundInfoRow}
        mode={'EDIT'}
        i={i}
        updateActiveInboundList={updateActiveInboundList}
        closeEditMode={() => setShowEditConfigModal(false)}
      />
    );
  } else {
    return (
      <DisplayRow
        inboundInfoRow={inboundInfoRow}
        i={i}
        setShowEditConfigModal={setShowEditConfigModal}
      />
    );
  }
}

function DisplayRow({
  inboundInfoRow,
  i,
  setShowEditConfigModal,
}: {
  inboundInfoRow: InboundInfoFormatted;
  i: number;
  setShowEditConfigModal: (boolean) => void;
}): JSX.Element {
  return (
    <TableRow key={`${inboundInfoRow.name}-${i}`} component="div">
      <TableCell component="div">
        <ButtonComponent
          variant={'outlined'}
          onClick={() => {
            analyticsWrapper.event({
              category: 'inBound-config',
              action: `edit-inbound-row`,
              label: 'click',
            });
            setShowEditConfigModal(true);
          }}
          startIcon={<FaPencilAlt />}
        >
          {'edit'}
        </ButtonComponent>
      </TableCell>
      <TableCell component="div">
        <span>{inboundInfoRow.name}</span>
      </TableCell>
      <TableCell component="div">
        {courierName(inboundInfoRow.courier)}
      </TableCell>
      <TableCell component="div">
        <ShowShops shopList={inboundInfoRow && inboundInfoRow.shopArray} />
      </TableCell>
    </TableRow>
  );
}

function CreateInboundData({
  inboundInfoRow = null,
  mode,
  i,
  updateActiveInboundList,
  closeEditMode,
}: {
  inboundInfoRow: InboundInfoFormatted;
  mode: string;
  i: number;
  updateActiveInboundList: (
    newInboundItem: InboundInfoFormatted,
    indexOfNewInboundItem: number,
    type: string
  ) => void;
  closeEditMode: () => void;
}): JSX.Element {
  const [newName, setNewName] = useState<string>(
    inboundInfoRow ? inboundInfoRow.name : ''
  );

  const [shopList, setShopList] = useState<ShopArray[]>(
    inboundInfoRow &&
      inboundInfoRow.shopArray &&
      inboundInfoRow.shopArray.length > 0
      ? inboundInfoRow.shopArray
      : []
  );

  const [courierObj, setCourierObj] = useState<CourierObj>(
    inboundInfoRow && inboundInfoRow.courier ? inboundInfoRow.courier : null
  );

  function addShopMethod(newShop: ShopArray[]) {
    setShopList(newShop);
  }

  const updateBackend = async () => {
    const newInboundId = inboundInfoRow?.id;
    const assignedCourierId: number = courierObj ? courierObj.id : null;
    const assignedCourierObj: CourierObj = courierObj
      ? courierObj
      : {
          id: assignedCourierId,
          firstName: 'place',
          lastName: 'holder',
        };
    const accountIdsAsList: number[] =
      shopList && shopList.length > 0
        ? shopList.map((obj: ShopArray) => obj.id)
        : [];

    let inboundInfoListResult: boolean;

    if (newInboundId) {
      inboundInfoListResult = await fetchUpdateInbound(
        newInboundId,
        newName,
        accountIdsAsList,
        assignedCourierId
      );
    } else {
      inboundInfoListResult = await fetchCreateInbound(
        newName,
        accountIdsAsList,
        assignedCourierId
      );
    }
    if (mode === 'EDIT' && inboundInfoListResult) {
      const inboundTest: InboundInfoFormatted = {
        id: newInboundId,
        name: newName,
        shopArray: shopList ? shopList : [],
        courier: courierObj,
      };
      updateActiveInboundList(inboundTest, i, 'REPLACE');
      closeEditMode();
    } else if (mode === 'ADD' && inboundInfoListResult) {
      const inboundTest: InboundInfoFormatted = {
        id: newInboundId,
        name: newName,
        shopArray: shopList ? shopList : [],
        courier: assignedCourierObj,
      };
      updateActiveInboundList(inboundTest, i, 'ADD');
      closeEditMode();
    }
  };

  const deleteInbound = async () => {
    const InboundInfoListResult = fetchRemoveInbound(inboundInfoRow.id);
    if (InboundInfoListResult) {
      updateActiveInboundList(inboundInfoRow, i, 'DELETE');
      closeEditMode();
    }
  };

  return (
    <>
      <TableRow key={`1xyz`} component="div">
        <TableCell component="div">
          {mode === 'EDIT' && (
            <ButtonComponent
              variant="outlined"
              onClick={async () => {
                analyticsWrapper.event({
                  category: 'inBound-config',
                  action: `delete-edit-inbound-row`,
                  label: 'click',
                });
                await deleteInbound();
              }}
              startIcon={<FcDeleteRow />}
            >
              {'Delete'}
            </ButtonComponent>
          )}
          {mode === 'ADD' && (
            <ButtonComponent
              variant="outlined"
              onClick={async () => {
                analyticsWrapper.event({
                  category: 'inBound-config',
                  action: `save-add-inbound-row`,
                  label: 'click',
                });
                await updateBackend();
              }}
              startIcon={<FaSave />}
            >
              {'Save'}
            </ButtonComponent>
          )}
          {mode === 'EDIT' && (
            <ButtonComponent
              variant="outlined"
              onClick={async () => {
                analyticsWrapper.event({
                  category: 'inBound-config',
                  action: `save-edit-inbound-row`,
                  label: 'click',
                });
                await updateBackend();
              }}
              startIcon={<FaSave />}
            >
              {'Save'}
            </ButtonComponent>
          )}
        </TableCell>
        <TableCell component="div">
          <div className="capacity-store__editable">
            <InputComponent
              id="name"
              label="name"
              name="name"
              onChange={e => {
                setNewName(e.target.value);
              }}
              variant="outlined"
              size="small"
              margin="dense"
              value={newName}
            />
          </div>
        </TableCell>
        <TableCell key={`courierlist`} component="div">
          <EditCourierBox
            currentCourier={inboundInfoRow && inboundInfoRow.courier}
            setCourierObj={setCourierObj}
          />
        </TableCell>
        <TableCell key={`shoplist`} component="div">
          <EditShops shopList={shopList} addShopMethod={addShopMethod} />
        </TableCell>
      </TableRow>
    </>
  );
}
